import React, { memo, useCallback } from 'react'

const PartsList = ({
  list,
  subLink,
  categoriesPartIndex,
  Link,
  subText,
  handleCategoryPartsonClick,
}) => {
  const onClick = useCallback(
    () => handleCategoryPartsonClick(subText, subLink),
    [handleCategoryPartsonClick, subLink, subText],
  )

  const itemKey = `${categoriesPartIndex}${subText.replace(/ /g, '_')}`
  const subId = `${itemKey}`

  return (
    <li
      key={itemKey}
    >
      <input
        type="checkbox"
        id={subId}
        onClick={onClick}
      />
      <label
        className="tree_label"
        htmlFor={subId}
        key={itemKey}
      >
        {subText}
      </label>
      <ul>
        {list && list[subLink] && list[subLink].map(
          ({
            text: partText,
            link: partLink,
          }) => (
            <li
              key={`${categoriesPartIndex}tree${partText}`}
            >
              <Link to={partLink}>
                <span className="tree_label link">
                  {partText}
                </span>
              </Link>
            </li>
          ),
        )}
      </ul>
    </li>
  )
}

export default memo(PartsList)
